import { formatPrice } from "@/Helpers/formatPrice";

// Review screen money copy. When there's tax, customers compared the before-tax
// price but the real charge/invoice is the tax-included total, so we state both
// to avoid an "I thought I was paying X" surprise. When there's no separate tax
// the two amounts are identical, so we keep the simpler single-amount wording.
interface BookingChargeSummaryProps {
  priceBeforeTax: number;
  taxAmount: number;
  total: number;
  currency: string;
  paymentTermsDays: number;
  hasSelectedCard: boolean;
  hasSelectedBankAccount: boolean;
}

export function BookShipmentBookingChargeSummary(
  props: BookingChargeSummaryProps,
) {
  const { priceBeforeTax, taxAmount, total, currency, paymentTermsDays } =
    props;

  const totalAfterTax = (
    <strong className="text-foreground">
      ${formatPrice(total)} {currency}
    </strong>
  );

  // No separate tax: before-tax equals the total, so keep it simple.
  if (taxAmount === 0) {
    if (paymentTermsDays !== 0) {
      return (
        <div className="text-base text-content-muted">
          An invoice for {totalAfterTax} will be issued (due in{" "}
          {paymentTermsDays} days).
        </div>
      );
    }
    if (props.hasSelectedCard) {
      return (
        <div className="text-base text-content-muted">
          A charge of {totalAfterTax} will be made to your card.
        </div>
      );
    }
    if (props.hasSelectedBankAccount) {
      return (
        <div className="text-base text-content-muted">
          A charge of {totalAfterTax} will be made to your bank account.
        </div>
      );
    }
    return <></>;
  }

  const beforeTax = (
    <strong className="text-foreground">
      ${formatPrice(priceBeforeTax)} {currency}
    </strong>
  );
  const taxNote = ` (including $${formatPrice(taxAmount)} ${currency} tax)`;

  if (paymentTermsDays !== 0) {
    return (
      <div className="text-base text-content-muted">
        Your price is {beforeTax} before tax. An invoice for {totalAfterTax}
        {taxNote} will be issued (due in {paymentTermsDays} days).
      </div>
    );
  }

  if (props.hasSelectedCard) {
    return (
      <div className="text-base text-content-muted">
        Your price is {beforeTax} before tax. A charge of {totalAfterTax}
        {taxNote} will be made to your card.
      </div>
    );
  }

  if (props.hasSelectedBankAccount) {
    return (
      <div className="text-base text-content-muted">
        Your price is {beforeTax} before tax. A charge of {totalAfterTax}
        {taxNote} will be made to your bank account.
      </div>
    );
  }

  return <></>;
}
